<div id="{{ id }}" class="{{ defaultClasses }}" role="alert" [attr.aria-hidden]="ariaState" aria-live="polite" [@fadeInOut]>
  @if (displayIcon) {
    <i class="fa fa-triangle-exclamation text-primary pe-2" aria-hidden="true"></i>
  }
  <span>{{downloadPrompt}}<a #link [href]="url" (click)="linkClicked()" [attr.download]="filename" [attr.target]="target">{{downloadLinkText}}</a>.</span>
</div>
